// const DELIVERY_DEFAULTS = Object.freeze({
//   processingMin: 1,
//   processingMax: 2,
//   transitMin: 2,
//   transitMax: 4,
//   cutoffHour: 12,
// });

// class NordanDeliveryEstimate extends HTMLElement {
//   connectedCallback() {
//     if (this.dataset.initialized === 'true') return;
//     this.dataset.initialized = 'true';

//     try {
//       this.renderEstimate();
//     } catch {
//       this.dataset.ready = 'false';
//     }
//   }

//   renderEstimate() {
//     const fallback = this.querySelector('[data-delivery-fallback]');
//     const dynamic = this.querySelector('[data-delivery-dynamic]');
//     const notice = this.querySelector('[data-delivery-notice]');
//     const orderedLabel = this.querySelector('[data-delivery-ordered-label]');
//     const readyLabel = this.querySelector('[data-delivery-ready-label]');
//     const deliveredLabel = this.querySelector('[data-delivery-delivered-label]');
//     const orderedDate = this.querySelector('[data-delivery-ordered-date]');
//     const readyDate = this.querySelector('[data-delivery-ready-date]');
//     const deliveredDate = this.querySelector('[data-delivery-delivered-date]');

//     if (
//       !fallback ||
//       !dynamic ||
//       !orderedLabel ||
//       !readyLabel ||
//       !deliveredLabel ||
//       !orderedDate ||
//       !readyDate ||
//       !deliveredDate
//     ) {
//       return;
//     }

//     const processingRange = this.getNormalizedRange(
//       this.dataset.processingMin,
//       this.dataset.processingMax,
//       DELIVERY_DEFAULTS.processingMin,
//       DELIVERY_DEFAULTS.processingMax
//     );
//     const transitRange = this.getNormalizedRange(
//       this.dataset.transitMin,
//       this.dataset.transitMax,
//       DELIVERY_DEFAULTS.transitMin,
//       DELIVERY_DEFAULTS.transitMax
//     );
//     const cutoffHour = Math.min(
//       23,
//       this.getNonNegativeNumber(this.dataset.cutoffHour, DELIVERY_DEFAULTS.cutoffHour)
//     );

//     const now = new Date();
//     const ordered = this.atLocalNoon(now);
//     const processingStart = this.getProcessingStart(now, cutoffHour);
//     const readyMin = this.addBusinessDays(processingStart, processingRange.min);
//     const readyMax = this.addBusinessDays(processingStart, processingRange.max);
//     const deliveredMin = this.addBusinessDays(readyMin, transitRange.min);
//     const deliveredMax = this.addBusinessDays(readyMax, transitRange.max);
//     const locale = this.getLocale();

//     const deliveredIncludesYear =
//       deliveredMin.getFullYear() !== ordered.getFullYear() ||
//       deliveredMax.getFullYear() !== ordered.getFullYear() ||
//       deliveredMin.getFullYear() !== deliveredMax.getFullYear();
//     const minDate = this.formatDate(deliveredMin, locale, deliveredIncludesYear);
//     const maxDate = this.formatDate(deliveredMax, locale, deliveredIncludesYear);
//     const noticeTemplate = this.dataset.noticeTemplate || '';

//     if (notice) {
//       notice.textContent = noticeTemplate
//         .split('{min_date}')
//         .join(minDate)
//         .split('{max_date}')
//         .join(maxDate);
//     }
//     orderedLabel.textContent = this.dataset.orderedLabel || '';
//     readyLabel.textContent = this.dataset.readyLabel || '';
//     deliveredLabel.textContent = this.dataset.deliveredLabel || '';
//     orderedDate.textContent = this.formatDate(ordered, locale, ordered.getFullYear() !== now.getFullYear());
//     readyDate.textContent = this.formatRange(readyMin, readyMax, locale, ordered.getFullYear());
//     deliveredDate.textContent = this.formatRange(deliveredMin, deliveredMax, locale, ordered.getFullYear());

//     fallback.hidden = true;
//     dynamic.hidden = false;
//     this.dataset.ready = 'true';
//   }

//   getNonNegativeNumber(value, fallback) {
//     const number = Number(value);
//     return Number.isFinite(number) ? Math.max(0, number) : fallback;
//   }

//   getNormalizedRange(minValue, maxValue, defaultMin, defaultMax) {
//     const first = this.getNonNegativeNumber(minValue, defaultMin);
//     const second = this.getNonNegativeNumber(maxValue, defaultMax);

//     return {
//       min: Math.min(first, second),
//       max: Math.max(first, second),
//     };
//   }

//   atLocalNoon(date) {
//     const normalized = new Date(date);
//     normalized.setHours(12, 0, 0, 0);
//     return normalized;
//   }

//   isWeekend(date) {
//     return date.getDay() === 0 || date.getDay() === 6;
//   }

//   getNextBusinessDay(date) {
//     const next = this.atLocalNoon(date);

//     do {
//       next.setDate(next.getDate() + 1);
//     } while (this.isWeekend(next));

//     return next;
//   }

//   getProcessingStart(now, cutoffHour) {
//     const start = this.atLocalNoon(now);

//     if (this.isWeekend(start)) {
//       return this.getNextBusinessDay(start);
//     }

//     if (now.getHours() >= cutoffHour) {
//       return this.getNextBusinessDay(start);
//     }

//     return start;
//   }

//   addBusinessDays(date, days) {
//     const result = this.atLocalNoon(date);
//     let remaining = Math.floor(Math.max(0, days));

//     while (remaining > 0) {
//       result.setDate(result.getDate() + 1);
//       if (!this.isWeekend(result)) remaining -= 1;
//     }

//     return result;
//   }

//   getLocale() {
//     const locale = document.documentElement.lang?.trim() || 'en-US';

//     try {
//       new Intl.DateTimeFormat(locale).format();
//       return locale;
//     } catch {
//       return 'en-US';
//     }
//   }

//   isSameDate(first, second) {
//     return (
//       first.getFullYear() === second.getFullYear() &&
//       first.getMonth() === second.getMonth() &&
//       first.getDate() === second.getDate()
//     );
//   }

//   formatDate(date, locale, includeYear) {
//     return new Intl.DateTimeFormat(locale, {
//       month: 'short',
//       day: 'numeric',
//       ...(includeYear ? { year: 'numeric' } : {}),
//     }).format(date);
//   }

//   formatRange(minDate, maxDate, locale, currentYear) {
//     if (this.isSameDate(minDate, maxDate)) {
//       return this.formatDate(minDate, locale, minDate.getFullYear() !== currentYear);
//     }

//     const includeYear =
//       minDate.getFullYear() !== currentYear ||
//       maxDate.getFullYear() !== currentYear ||
//       minDate.getFullYear() !== maxDate.getFullYear();

//     return `${this.formatDate(minDate, locale, includeYear)} – ${this.formatDate(maxDate, locale, includeYear)}`;
//   }

// }

// if (!customElements.get('nordan-delivery-estimate')) {
//   customElements.define('nordan-delivery-estimate', NordanDeliveryEstimate);
// }
const DELIVERY_DEFAULTS = Object.freeze({
  processingMin: 1,
  processingMax: 2,
  transitMin: 2,
  transitMax: 4,
  cutoffHour: 12,
});

const deliveryClock = {
  instances: new Set(),
  timer: null,
  add(instance) {
    this.instances.add(instance);
    if (this.instances.size === 1) document.addEventListener('visibilitychange', this.onVisibility);
    this.schedule();
  },
  remove(instance) {
    this.instances.delete(instance);
    if (!this.instances.size) document.removeEventListener('visibilitychange', this.onVisibility);
    this.schedule();
  },
  schedule() {
    clearTimeout(this.timer);
    this.timer = null;
    if (document.hidden || !this.instances.size) return;
    const now = new Date();
    let delay = 60000;
    for (const instance of this.instances) delay = Math.min(delay, instance.nextCheckDelay(now));
    this.timer = setTimeout(() => {
      this.timer = null;
      const current = new Date();
      for (const instance of this.instances) instance.refresh(current);
      this.schedule();
    }, Math.max(1, delay));
  },
  onVisibility() {
    if (!document.hidden) {
      const now = new Date();
      for (const instance of deliveryClock.instances) instance.refresh(now);
    }
    deliveryClock.schedule();
  },
};

class NordanDeliveryEstimate extends HTMLElement {
  static observedAttributes = [
    'data-processing-min', 'data-processing-max', 'data-transit-min', 'data-transit-max',
    'data-cutoff-hour', 'data-delivery-from-order', 'data-order-cutoff-aligned', 'data-display-style', 'data-variant-available',
    'data-show-stock', 'data-stock-text', 'data-show-cutoff', 'data-max-hours',
    'data-template-a', 'data-template-b', 'data-template-c', 'data-hour-unit', 'data-hours-unit',
    'data-today-text', 'data-tomorrow-text',
    'data-font-size', 'data-min-font-size', 'data-icon-size',
    'data-mobile-template-a', 'data-mobile-template-b', 'data-mobile-template-c',
  ];

  connectedCallback() {
    if (this.deliveryConnected) return;
    this.deliveryConnected = true;
    this.dataset.initialized = 'true';
    this.variantGeneration = (this.variantGeneration || 0) + 1;
    this.onVariant = this.onVariant.bind(this);
    this.section = this.closest('.shopify-section');
    this.section?.addEventListener('shopify:product:select', this.onVariant);
    this.syncCompactLayout();
    if (!this.refresh() || this.dataset.displayStyle === 'compact') this.watchContent();
    deliveryClock.add(this);
  }

  disconnectedCallback() {
    this.deliveryConnected = false;
    this.clearCompactLayout();
    this.variantGeneration++;
    this.parserObserver?.disconnect();
    this.parserObserver = null;
    this.section?.removeEventListener('shopify:product:select', this.onVariant);
    this.section = null;
    deliveryClock.remove(this);
  }

  attributeChangedCallback() {
    if (!this.deliveryConnected) return;
    this.syncCompactLayout();
    if (!this.refresh() || this.dataset.displayStyle === 'compact') this.watchContent();
    deliveryClock.schedule();
  }

  watchContent() {
    if (this.parserObserver) return;
    this.parserObserver = new MutationObserver(() => {
      if (!this.deliveryConnected) return;
      if (this.refresh() && this.dataset.displayStyle !== 'compact') {
        this.parserObserver.disconnect();
        this.parserObserver = null;
      }
    });
    this.parserObserver.observe(this, { childList: true, subtree: true, characterData: true });
  }

  refresh(now = new Date()) {
    try {
      return this.renderEstimate(now);
    } catch {
      this.dataset.ready = 'false';
      return false;
    } finally {
      this.fitCompact();
    }
  }

  syncCompactLayout() {
    if (this.dataset.displayStyle !== 'compact') {
      this.clearCompactLayout();
      return;
    }
    if (this.compactLayoutAttached) return;
    this.compactLayoutAttached = true;
    this.onCompactMedia = () => this.refresh();
    this.onCompactFit = () => this.fitCompact();
    if (typeof window !== 'undefined') {
      this.mobileMedia = window.matchMedia('(max-width: 749px)');
      this.mobileMedia.addEventListener('change', this.onCompactMedia);
    }
    if (typeof ResizeObserver === 'function') {
      this.compactResize = new ResizeObserver((entries) => {
        const width = entries[0]?.contentRect.width;
        if (!Number.isFinite(width) || width <= 0 || width === this.lastCompactWidth) return;
        this.lastCompactWidth = width;
        this.fitCompact();
      });
      this.compactResize.observe(this);
    } else if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.onCompactFit);
    }
    document.fonts?.addEventListener('loadingdone', this.onCompactFit);
    document.fonts?.ready.then(() => {
      if (this.deliveryConnected && this.compactLayoutAttached) this.fitCompact();
    });
  }

  clearCompactLayout() {
    if (!this.compactLayoutAttached) return;
    this.compactLayoutAttached = false;
    this.compactResize?.disconnect();
    this.compactResize = null;
    this.lastCompactWidth = undefined;
    this.mobileMedia?.removeEventListener('change', this.onCompactMedia);
    this.mobileMedia = null;
    if (typeof window !== 'undefined') window.removeEventListener('resize', this.onCompactFit);
    document.fonts?.removeEventListener('loadingdone', this.onCompactFit);
    this.style.removeProperty('--nordan-compact-fit-font-size');
    this.style.removeProperty('--nordan-compact-fit-icon-size');
    const copy = this.querySelector('[data-delivery-compact-copy]');
    copy?.style.removeProperty('white-space');
    delete this.dataset.fitReady;
  }

  fitCompact() {
    if (!this.deliveryConnected || this.dataset.displayStyle !== 'compact' || !this.clientWidth) return;
    const copy = this.querySelector('[data-delivery-compact-copy]');
    if (!copy) return;
    const base = Math.min(18, Math.max(12, this.getNonNegativeNumber(this.dataset.fontSize, 14)));
    const minimum = Math.min(base, Math.min(14, Math.max(10, this.getNonNegativeNumber(this.dataset.minFontSize, 11))));
    const iconSize = Math.min(28, Math.max(12, this.getNonNegativeNumber(this.dataset.iconSize, 18)));
    const apply = (size) => {
      this.style.setProperty('--nordan-compact-fit-font-size', size + 'px');
      this.style.setProperty('--nordan-compact-fit-icon-size', (iconSize * size / base) + 'px');
    };
    copy.style.whiteSpace = 'nowrap';
    this.dataset.fitReady = 'true';
    let size = base;
    apply(size);
    while (copy.scrollWidth > copy.clientWidth && size > minimum) {
      size = Math.max(minimum, size - 0.5);
      apply(size);
    }
    if (copy.scrollWidth > copy.clientWidth) copy.style.whiteSpace = 'normal';
  }

  onVariant(event) {
    if (this.dataset.displayStyle !== 'compact' || !event.promise ||
        String(event.product?.id || '').split('/').pop() !== this.dataset.productId ||
        event.target?.closest('product-card, quick-add-dialog')) return;
    const generation = ++this.variantGeneration;
    event.promise.then(({ detail }) => {
      if (!this.isConnected || generation !== this.variantGeneration) return;
      const incoming = Array.from(detail?.html?.querySelectorAll('nordan-delivery-estimate') || [])
        .find((node) => node.dataset.deliveryBlockId === this.dataset.deliveryBlockId &&
          node.dataset.productId === this.dataset.productId);
      if (!incoming) return;
      const confirmed = detail?.resource;
      const available = confirmed === null ? false : typeof confirmed?.available === 'boolean'
        ? confirmed.available : incoming.dataset.variantAvailable === 'true';
      this.dataset.variantAvailable = String(available);
      this.refresh();
    }, () => {});
  }

  calculateEstimate(now = new Date()) {
    const processingRange = this.getNormalizedRange(
      this.dataset.processingMin, this.dataset.processingMax,
      DELIVERY_DEFAULTS.processingMin, DELIVERY_DEFAULTS.processingMax
    );
    const transitRange = this.getNormalizedRange(
      this.dataset.transitMin, this.dataset.transitMax,
      DELIVERY_DEFAULTS.transitMin, DELIVERY_DEFAULTS.transitMax
    );
    const cutoffHour = Math.min(23, this.getNonNegativeNumber(this.dataset.cutoffHour, DELIVERY_DEFAULTS.cutoffHour));
    const ordered = this.atLocalNoon(now);
    const processingStart = this.getProcessingStart(now, cutoffHour);
    const readyMin = this.addBusinessDays(processingStart, processingRange.min);
    const readyMax = this.addBusinessDays(processingStart, processingRange.max);
    const deliveryFromOrder = this.dataset.deliveryFromOrder === 'true';
    const orderStart = this.dataset.orderCutoffAligned === 'true' ? processingStart : ordered;
    const deliveredMin = deliveryFromOrder
      ? this.addBusinessDays(orderStart, transitRange.min)
      : this.addCalendarDays(readyMin, transitRange.min);
    const deliveredMax = deliveryFromOrder
      ? this.addBusinessDays(orderStart, transitRange.max)
      : this.addCalendarDays(readyMax, transitRange.max);
    return { ordered, readyMin, readyMax, deliveredMin, deliveredMax, cutoffHour };
  }

  getNextCutoff(now, cutoffHour) {
    const next = this.getProcessingStart(now, cutoffHour);
    next.setHours(cutoffHour, 0, 0, 0);
    return next;
  }

  getCountdown(now, cutoffHour) {
    const cutoff = this.getNextCutoff(now, cutoffHour);
    const remaining = cutoff.getTime() - now.getTime();
    const maximum = Math.min(12, Math.max(1, this.getNonNegativeNumber(this.dataset.maxHours, 3)));
    return { cutoff, remaining, hours: Math.min(maximum, Math.floor(remaining / 3600000)) };
  }

  nextCheckDelay(now) {
    const cutoffHour = Math.min(23, this.getNonNegativeNumber(this.dataset.cutoffHour, DELIVERY_DEFAULTS.cutoffHour));
    const { remaining, hours } = this.getCountdown(now, cutoffHour);
    const boundary = hours >= 1 ? remaining - hours * 3600000 + 1 : remaining;
    return Math.min(60000, Math.max(1, boundary));
  }

  escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    }[character]));
  }

  compactHtml(estimate, now) {
    const { ordered, deliveredMin, deliveredMax, cutoffHour } = estimate;
    const locale = this.getLocale();
    const includeYear = deliveredMin.getFullYear() !== ordered.getFullYear() ||
      deliveredMax.getFullYear() !== ordered.getFullYear() || deliveredMin.getFullYear() !== deliveredMax.getFullYear();
    const countdown = this.getCountdown(now, cutoffHour);
    const showCutoff = this.dataset.showCutoff !== 'false';
    const mode = !showCutoff ? 'c' : countdown.remaining < 3600000 ? 'b' : 'a';
    const mobileTemplate = this.mobileMedia?.matches ? this.dataset['mobileTemplate' + mode.toUpperCase()] : '';
    const template = mobileTemplate?.trim() ? mobileTemplate : this.dataset['template' + mode.toUpperCase()] || '';
    const stock = this.dataset.showStock !== 'false' && this.dataset.variantAvailable === 'true' && this.dataset.stockText
      ? '<span class="nordan-delivery-estimate__stock">' + this.escapeHtml(this.dataset.stockText) + '</span>,' : '';
    const time = new Intl.DateTimeFormat(locale, {
      hour: 'numeric', ...(countdown.cutoff.getMinutes() ? { minute: '2-digit' } : {}), hour12: true,
    }).format(countdown.cutoff);
    const values = {
      stock,
      min_date: this.escapeHtml(this.formatDate(deliveredMin, locale, includeYear)),
      max_date: this.escapeHtml(this.formatDate(deliveredMax, locale, includeYear)),
      countdown: this.escapeHtml(countdown.hours + ' ' + (countdown.hours === 1 ? this.dataset.hourUnit : this.dataset.hoursUnit)),
      cutoff_time: this.escapeHtml(time),
      cutoff_day: this.escapeHtml(this.isSameDate(countdown.cutoff, now) ? this.dataset.todayText : this.dataset.tomorrowText),
    };
    return this.escapeHtml(template).replace(/&lt;(\/?)strong&gt;/gi, '<$1strong>')
      .replace(/\{(stock|min_date|max_date|countdown|cutoff_time|cutoff_day)\}/g, (_, key) => values[key]).trim();
  }

  renderEstimate(now = new Date()) {
    const estimate = this.calculateEstimate(now);
    if (this.dataset.displayStyle === 'compact') {
      if (!this.querySelector('[data-delivery-content-ready]')) return false;
      const copy = this.querySelector('[data-delivery-compact-copy]');
      if (!copy) return false;
      const html = this.compactHtml(estimate, now);
      if (html !== this.lastCompactHtml || copy !== this.lastCompactNode || copy.innerHTML !== this.lastCompactRenderedHtml) {
        copy.innerHTML = html;
        this.lastCompactHtml = html;
        this.lastCompactNode = copy;
        this.lastCompactRenderedHtml = copy.innerHTML;
      }
      this.dataset.ready = 'true';
      return true;
    }
    const fallback = this.querySelector('[data-delivery-fallback]');
    const dynamic = this.querySelector('[data-delivery-dynamic]');
    const notice = this.querySelector('[data-delivery-notice]');
    const orderedLabel = this.querySelector('[data-delivery-ordered-label]');
    const readyLabel = this.querySelector('[data-delivery-ready-label]');
    const deliveredLabel = this.querySelector('[data-delivery-delivered-label]');
    const orderedDate = this.querySelector('[data-delivery-ordered-date]');
    const readyDate = this.querySelector('[data-delivery-ready-date]');
    const deliveredDate = this.querySelector('[data-delivery-delivered-date]');
    if (!fallback || !dynamic || !orderedLabel || !readyLabel || !deliveredLabel ||
        !orderedDate || !readyDate || !deliveredDate) return false;
    const { ordered, readyMin, readyMax, deliveredMin, deliveredMax } = estimate;
    const locale = this.getLocale();
    const includeYear = deliveredMin.getFullYear() !== ordered.getFullYear() ||
      deliveredMax.getFullYear() !== ordered.getFullYear() || deliveredMin.getFullYear() !== deliveredMax.getFullYear();
    if (notice) notice.textContent = (this.dataset.noticeTemplate || '')
      .split('{min_date}').join(this.formatDate(deliveredMin, locale, includeYear))
      .split('{max_date}').join(this.formatDate(deliveredMax, locale, includeYear));
    orderedLabel.textContent = this.dataset.orderedLabel || '';
    readyLabel.textContent = this.dataset.readyLabel || '';
    deliveredLabel.textContent = this.dataset.deliveredLabel || '';
    orderedDate.textContent = this.formatDate(ordered, locale, ordered.getFullYear() !== now.getFullYear());
    readyDate.textContent = this.formatRange(readyMin, readyMax, locale, ordered.getFullYear());
    deliveredDate.textContent = this.formatRange(deliveredMin, deliveredMax, locale, ordered.getFullYear());
    fallback.hidden = true;
    dynamic.hidden = false;
    this.dataset.ready = 'true';
    return true;
  }

  getNonNegativeNumber(value, fallback) {
    const number = Number(value);
    return Number.isFinite(number) ? Math.max(0, number) : fallback;
  }

  getNormalizedRange(minValue, maxValue, defaultMin, defaultMax) {
    const first = this.getNonNegativeNumber(minValue, defaultMin);
    const second = this.getNonNegativeNumber(maxValue, defaultMax);

    return {
      min: Math.min(first, second),
      max: Math.max(first, second),
    };
  }

  atLocalNoon(date) {
    const normalized = new Date(date);
    normalized.setHours(12, 0, 0, 0);
    return normalized;
  }

  isWeekend(date) {
    return date.getDay() === 0 || date.getDay() === 6;
  }

  getNextBusinessDay(date) {
    const next = this.atLocalNoon(date);

    do {
      next.setDate(next.getDate() + 1);
    } while (this.isWeekend(next));

    return next;
  }

  getProcessingStart(now, cutoffHour) {
    const start = this.atLocalNoon(now);

    if (this.isWeekend(start)) {
      return this.getNextBusinessDay(start);
    }

    if (now.getHours() >= cutoffHour) {
      return this.getNextBusinessDay(start);
    }

    return start;
  }

  addBusinessDays(date, days) {
    const result = this.atLocalNoon(date);
    let remaining = Math.floor(Math.max(0, days));

    while (remaining > 0) {
      result.setDate(result.getDate() + 1);
      if (!this.isWeekend(result)) remaining -= 1;
    }

    return result;
  }

  // 新增：直接加自然日（包含周末）
  addCalendarDays(date, days) {
    const result = this.atLocalNoon(date);
    const totalDays = Math.floor(Math.max(0, days));
    result.setDate(result.getDate() + totalDays);
    return result;
  }

  getLocale() {
    const locale = document.documentElement.lang?.trim() || 'en-US';

    try {
      new Intl.DateTimeFormat(locale).format();
      return locale;
    } catch {
      return 'en-US';
    }
  }

  isSameDate(first, second) {
    return (
      first.getFullYear() === second.getFullYear() &&
      first.getMonth() === second.getMonth() &&
      first.getDate() === second.getDate()
    );
  }

  formatDate(date, locale, includeYear) {
    return new Intl.DateTimeFormat(locale, {
      month: 'short',
      day: 'numeric',
      ...(includeYear ? { year: 'numeric' } : {}),
    }).format(date);
  }

  formatRange(minDate, maxDate, locale, currentYear) {
    if (this.isSameDate(minDate, maxDate)) {
      return this.formatDate(minDate, locale, minDate.getFullYear() !== currentYear);
    }

    const includeYear =
      minDate.getFullYear() !== currentYear ||
      maxDate.getFullYear() !== currentYear ||
      minDate.getFullYear() !== maxDate.getFullYear();

    return `${this.formatDate(minDate, locale, includeYear)} – ${this.formatDate(maxDate, locale, includeYear)}`;
  }

}

if (!customElements.get('nordan-delivery-estimate')) {
  customElements.define('nordan-delivery-estimate', NordanDeliveryEstimate);
}

if (!customElements.get('nordan-delivery-estimate')) {
  customElements.define('nordan-delivery-estimate', NordanDeliveryEstimate);
}
